// extracted by mini-css-extract-plugin
export default {"container":"MypageLayout_container__iWS0-"};